<template>
	<div>
		<PageHeaderLayout>
			<div class="main-page-content">
				<el-row class="table-search">
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
						<el-form-item v-for="item in searchList" :key="item.props" :label="item.label">
							<el-input
								v-if="item.type === 'input'"
								v-model="searchCondition[item.props]"
								:placeholder="'请输入' + item.label"
								clearable
							></el-input>
							<el-select
								v-if="item.type === 'select'"
								v-model="searchCondition[item.props]"
								:placeholder="'请选择' + item.label"
								clearable
							>
								<el-option v-for="option in item.selectData" :key="option.value" :label="option.label" :value="option.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton">查询</el-button>
						</el-form-item>
					</el-form>
				</el-row>
				<ApeTable
					ref="apeTable"
					:data="tableData"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					highlight-current-row
				>
					<el-table-column label="操作" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" size="mini" @click="goDetail(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import { search_list, tableColumns } from './config/insuranceManage.ts'

export default {
	name: 'InsuranceManage',
	components: {
		PageHeaderLayout,
		ApeTable
	},
	data() {
		return {
			searchCondition: {},
			searchList: search_list,
			loadingStaus: true,
			tableData: [],
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			columns: tableColumns
		}
	},
	methods: {
		searchButton() {
			this.initList('search')
		},
		switchPaging() {
			this.initList()
		},
		goDetail(row) {
			this.$router.push({
				path: '/manager/insuranceDetail',
				query: {
					taxpayer: row.taxpayer,
					product_plan_id: row.product_product_plan_id,
					job_level: row.job_level
				}
			})
		},
		formatList(list) {
			const jobLevelMap = {
				1: '一类职业',
				2: '二类职业',
				3: '三类职业',
				4: '四类职业',
				5: '五类职业'
			}
			return list.map(item => {
				return {
					...item,
					job_level_text: jobLevelMap[item.job_level] || item.job_level || '-',
					product_premium: item.product_premium != null ? item.product_premium / 100 : '',
					product_sum_insured: item.product_sum_insured != null ? item.product_sum_insured / 100 : '',
					clock_mode_text: item.is_clock_work == 1 ? '考勤打卡' : '打卡直接投保'
				}
			})
		},
		async initList(type) {
			this.loadingStaus = true
			const pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
			if (type === 'search') {
				pagingInfo.current_page = 1
			}
			if (!this.$api.getAllClockLinkList) {
				this.loadingStaus = false
				this.$message.error('请先提供保险管理列表接口')
				return
			}
			try {
				const params = {
					...this.searchCondition,
					...pagingInfo,
					page: pagingInfo.current_page
				}
				delete params.current_page
				const res = await this.$api.getAllClockLinkList(params)
				const list = res.items || res.data || res.list || []
				this.tableData = this.formatList(list)
				this.pagingData.total = res.total || (res.pages && res.pages.total) || 0
				this.pagingData.offset = res.offset || (res.pages && res.pages.offset) || 0
			} catch (e) {
				this.tableData = []
				this.$message.error(e.message || '获取保险管理列表失败')
			}
			this.loadingStaus = false
		}
	},
	mounted() {
		this.initList()
	}
}
</script>

<style lang="scss" scoped>
.table-search {
	margin-bottom: 16px;
}
</style>
